import React, { memo } from 'react';

import './PastShiftBadge.scss';

const PastShiftBadge = ({ title }) => {
	return <div className="past_shift--badge">{title}</div>;
};

export default memo(PastShiftBadge);
